import { render, staticRenderFns } from "./projectSelectDialog.vue?vue&type=template&id=684af0bb&scoped=true"
import script from "./projectSelectDialog.vue?vue&type=script&lang=js"
export * from "./projectSelectDialog.vue?vue&type=script&lang=js"
import style0 from "./projectSelectDialog.vue?vue&type=style&index=0&id=684af0bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684af0bb",
  null
  
)

export default component.exports